import React, { useEffect } from "react";
import Context from "../../../../context";
import Component from "./Component";

import { ICreateStudent } from "../../../../types/student.interface";
import { CustomIcon, CustomModal } from "../../../../components";

import "./index.sass";
import { useTranslation } from "react-i18next";

const Create = ({
  role,
}: {
  role: "ADMIN" | "SUPER_AGENT_SCHOOL" | "COMPANY";
}) => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, createFunction } = React.useContext(
    Context.ServiceScreen
  );
  const [step, setStep] = React.useState<number>(1);
  const [formData, setFormData] = React.useState<ICreateStudent>({});

  function onBack(event: ICreateStudent) {
    setFormData({ ...formData, ...event });
    setStep(step - 1);
  }

  function onNext(event: ICreateStudent) {
    setFormData((prevFormData) => ({
      ...prevFormData,
      ...event,
    }));
    setStep(step + 1);
  }

  async function onSubmit(event: ICreateStudent) {
    const result = await createFunction!({ ...formData, ...event });
    if (result) {
      setStep(1);
      setFormData({});
    }
  }

  function RenderCreateService() {
    switch (step) {
      case 1:
        switch (role) {
          case "ADMIN":
            return (
              <Component.AdministratorStudentRelations
                defaultValues={formData}
                onSubmit={onNext}
              />
            );
          case "SUPER_AGENT_SCHOOL":
            return (
              <Component.SuperAgentStudentRelations
                defaultValues={formData}
                onSubmit={onNext}
              />
            );
          case "COMPANY":
            return (
              <Component.CompanyStudentRelations
                defaultValues={formData}
                onSubmit={onNext}
              />
            );
          default:
            return null;
        }
      case 2:
        return (
          <Component.StudentInformation
            defaultValues={formData}
            onSubmit={onNext}
            onBack={onBack}
          />
        );
      case 3:
        return (
          <Component.StudentLocation
            defaultValue={formData}
            onSubmit={onNext}
            onBack={onBack}
          />
        );
      case 4:
        return (
          <Component.StudentTiming
            defaultValue={formData}
            onSubmit={onSubmit}
            onBack={onBack}
          />
        );
      default:
        return null;
    }
  }

  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="student-create-modal-container">
      <CustomIcon
        icon="fa-sharp fa-solid fa-circle-plus"
        size="medium"
        hoverTitle={t("createStudent")}
        onClick={() => {
          setShowModal!("CREATE");
        }}
      />
      <CustomModal
        onClose={() => {
          setShowModal!("NONE");
          setFormData({});
          setStep(1);
        }}
        open={showModal === "CREATE"}
        minWidth={"35vw"}
      >
        <RenderCreateService />
      </CustomModal>
    </section>
  );
};

export default Create;
